/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Table_ColorInputs */

const en_speaker_manager_table_color = /** @type {(inputs: Speaker_Manager_Table_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colour`)
};

const fr_speaker_manager_table_color = /** @type {(inputs: Speaker_Manager_Table_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur`)
};

const de_speaker_manager_table_color = /** @type {(inputs: Speaker_Manager_Table_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe`)
};

const it_speaker_manager_table_color = /** @type {(inputs: Speaker_Manager_Table_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore`)
};

const ru_speaker_manager_table_color = /** @type {(inputs: Speaker_Manager_Table_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цвет`)
};

const es_speaker_manager_table_color = /** @type {(inputs: Speaker_Manager_Table_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

const zh_cn2_speaker_manager_table_color = /** @type {(inputs: Speaker_Manager_Table_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`颜色`)
};

const ja_speaker_manager_table_color = /** @type {(inputs: Speaker_Manager_Table_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`色`)
};

const hi_speaker_manager_table_color = /** @type {(inputs: Speaker_Manager_Table_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रंग`)
};

const pt_pt2_speaker_manager_table_color = /** @type {(inputs: Speaker_Manager_Table_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor`)
};

/**
* | output |
* | --- |
* | "Colour" |
*
* @param {Speaker_Manager_Table_ColorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_table_color = /** @type {((inputs?: Speaker_Manager_Table_ColorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Table_ColorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_table_color(inputs)
	if (locale === "de") return de_speaker_manager_table_color(inputs)
	if (locale === "it") return it_speaker_manager_table_color(inputs)
	if (locale === "ru") return ru_speaker_manager_table_color(inputs)
	if (locale === "es") return es_speaker_manager_table_color(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_table_color(inputs)
	if (locale === "ja") return ja_speaker_manager_table_color(inputs)
	if (locale === "hi") return hi_speaker_manager_table_color(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_table_color(inputs)
	return en_speaker_manager_table_color(inputs)
});